import { z } from 'zod';
export const toolTestErrorCategorySchema = z.enum([
    'NOT_FOUND',
    'VALIDATION_ERROR',
    'CLAIM_MISMATCH',
    'UPGRADE_REQUIRED',
    'UPSTREAM_TIMEOUT',
    'UPSTREAM_ERROR',
    'AUTH_FAILURE',
    'CONFIGURATION_ERROR',
]);
export const toolTestResultStatusSchema = z.enum(['success', 'upstream_http_error']);
export const toolTestSuccessSchema = z.object({
    status: z.literal(toolTestResultStatusSchema.enum.success),
    data: z.unknown().optional(),
});
export const toolTestUpstreamHttpErrorSchema = z.object({
    status: z.literal(toolTestResultStatusSchema.enum.upstream_http_error),
    httpStatus: z.number(),
    body: z.unknown().optional(),
});
export const toolTestEngineErrorSchema = z.object({
    error: toolTestErrorCategorySchema,
    message: z.string().optional(),
    requiredScope: z.string().optional(),
    fields: z.array(z.string()).optional(),
});
const toolTestSourceBodySchema = z.union([
    z.null(),
    z.boolean(),
    z.number(),
    z.string(),
    z.array(z.unknown()),
    z.record(z.string(), z.unknown()),
]);
export const toolTestResultSchema = z.union([
    toolTestSuccessSchema,
    toolTestUpstreamHttpErrorSchema,
    toolTestEngineErrorSchema,
]);
export var ToolTestSourceBodyFormatEnum;
(function (ToolTestSourceBodyFormatEnum) {
    ToolTestSourceBodyFormatEnum["JSON"] = "json";
    ToolTestSourceBodyFormatEnum["TEXT"] = "text";
    ToolTestSourceBodyFormatEnum["EMPTY"] = "empty";
    ToolTestSourceBodyFormatEnum["TRUNCATED"] = "truncated";
})(ToolTestSourceBodyFormatEnum || (ToolTestSourceBodyFormatEnum = {}));
export const toolTestSourceBodyFormatSchema = z.nativeEnum(ToolTestSourceBodyFormatEnum);
export const toolTestSourceResponseSchema = z.object({
    httpStatus: z.number(),
    bodyFormat: toolTestSourceBodyFormatSchema,
    body: toolTestSourceBodySchema,
});
export const toolTestRunSchema = z.object({
    result: toolTestResultSchema,
    sourceResponse: toolTestSourceResponseSchema.optional(),
});
//# sourceMappingURL=tool-test-result.js.map